module.exports = __webpack_public_path__ + "static/img/bg-banner-tec.5f9f5ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bg-banner-tec.png
// module id = 3Py1
// module chunks = 1